<template>
  <v-card>
    <v-data-table
      :headers="headers"
      :items="students"
      :hide-default-footer="true"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <details-students
          :id="item.actions.id"
          type-student="assingned"
        />
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex'
  import DetailsStudents from '@/views/dashboard/pages/panel/DetailsStudents'

  export default {
    components: {
      DetailsStudents,
    },
    data () {
      return {
        search: '',
        headers: [
          { text: 'Nombre', value: 'details.firstname', sortable: false },
          { text: 'Apellido', value: 'details.lastname', sortable: false },
          //{ text: 'Apellido', value: 'lastname' },
          { text: 'Padre', value: 'parent', sortable: false },
          { text: 'Acciones', value: 'actions', sortable: false },
        ],
        sortBy: 'details.lastname',
        sortDesc: false,
      }
    },
    computed: {
      ...mapState(['userData']),
      students () {
        //return this.userData.studentsAssigned.students.sort( (a,b ) => a.lastname < b.lastname );
        return this.userData.studentsAssigned
      },
    },
  }
</script>
